<ul class="nav nav-tabs nav-fill mb-1" id="pills-tab" role="tablist">
    <li class="nav-item" role="presentation">
        <button class="nav-link active" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" role="tab"
        aria-controls="pills-home" aria-selected="true">
            <strong>{{'USER.RESERVATIONS.reservations' | translate}}</strong>
        </button>
    </li>
    <li class="nav-item" role="presentation">
        <button class="nav-link" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" role="tab"
            aria-controls="pills-profile" aria-selected="false">
            <strong>{{'USER.RESERVATIONS.settings' | translate}}</strong>
        </button>
    </li>
</ul>
<div class="tab-content" id="pills-tabContent">
    <div class="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
        <ng-container *ngIf="reservations.length > 0; else noReservationsTemplate">
            <div class="list-group">
                <app-slot-reservaton-item [reservation]="reservation" [index]="i"
                    *ngFor="let reservation of reservations; let i=index">
                </app-slot-reservaton-item>
            </div>
        </ng-container>
        <ng-template #noReservationsTemplate>
            <small
                class="form-text text-muted">{{'USER.RESERVATIONS.SLOT.noReservationsWarningMsg' | translate}}</small>
        </ng-template>
    </div>
    <div class="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
        <form #settingsForm="ngForm" id="settingsForm" [formGroup]="formGroup">
            <div class="row mt-1">
                <div class="col">
                    <label style="display: block;">
                        {{'USER.RESERVATIONS.SLOT.startEndPeriodTitle' | translate}}</label>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>{{'USER.RESERVATIONS.SLOT.startPeriod' | translate}}</label>
                        <div class="input-group input-group-sm">
                            <input class="form-control" placeholder="yyyy-mm-dd" name="startPeriod" ngbDatepicker
                                #startPeriodDatepicker="ngbDatepicker" formControlName="startPeriod" readonly>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" (click)="startPeriodDatepicker.toggle()"
                                    type="button">
                                    <fa-icon [icon]="icons['faCalendarAlt']"></fa-icon>
                                </button>
                            </div>
                        </div>
                        <small
                            class="form-text text-muted">{{'USER.RESERVATIONS.SLOT.startPeriodHelpText' | translate}}</small>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{'USER.RESERVATIONS.SLOT.endPeriod' | translate}}</label>
                        <div class="input-group input-group-sm">
                            <input class="form-control" placeholder="yyyy-mm-dd" name="endPeriod" ngbDatepicker
                                #endPeriodDatepicker="ngbDatepicker" formControlName="endPeriod" readonly>
                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary" (click)="endPeriodDatepicker.toggle()"
                                    type="button">
                                    <fa-icon [icon]="icons['faCalendarAlt']"></fa-icon>
                                </button>
                            </div>
                        </div>
                        <small
                            class="form-text text-muted">{{'USER.RESERVATIONS.SLOT.endPeriodHelpText' | translate}}</small>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <hr />
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>{{'USER.RESERVATIONS.SLOT.startHour' | translate}}</label>
                        <!-- <input type="text" class="form-control form-control-sm" formControlName="startHour" /> -->
                        <ngb-timepicker formControlName="startHour" [spinners]="false" size="small"></ngb-timepicker>
                        <small
                            class="form-text text-muted">{{'USER.RESERVATIONS.SLOT.startHourHelpText' | translate}}</small>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{'USER.RESERVATIONS.SLOT.endHour' | translate}}</label>
                        <!-- <input type="text" class="form-control form-control-sm" formControlName="endHour" /> -->
                        <ngb-timepicker formControlName="endHour" [spinners]="false" size="small"></ngb-timepicker>
                        <small
                            class="form-text text-muted">{{'USER.RESERVATIONS.SLOT.endHourHelpText' | translate}}</small>
                    </div>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label>{{'USER.RESERVATIONS.SLOT.expireAfter' | translate}}</label>
                        <input type="text" class="form-control form-control-sm" formControlName="expireAfter" />
                        <small
                            class="form-text text-muted">{{'USER.RESERVATIONS.SLOT.expireAfterHelpText' | translate}}</small>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">{{'USER.RESERVATIONS.SLOT.mon' | translate}}</th>
                                <th scope="col">{{'USER.RESERVATIONS.SLOT.tue' | translate}}</th>
                                <th scope="col">{{'USER.RESERVATIONS.SLOT.wed' | translate}}</th>
                                <th scope="col">{{'USER.RESERVATIONS.SLOT.thu' | translate}}</th>
                                <th scope="col">{{'USER.RESERVATIONS.SLOT.fri' | translate}}</th>
                                <th scope="col">{{'USER.RESERVATIONS.SLOT.sat' | translate}}</th>
                                <th scope="col">{{'USER.RESERVATIONS.SLOT.sun' | translate}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    <app-slot-table-item [(slot)]="settings.mondaySlot"
                                        [(allowedPersons)]="settings.mondayAllowedPerson"></app-slot-table-item>
                                </td>
                                <td>
                                    <app-slot-table-item [(slot)]="settings.tuesdaySlot"
                                        [(allowedPersons)]="settings.tuesdayAllowedPerson"></app-slot-table-item>
                                </td>
                                <td>
                                    <app-slot-table-item [(slot)]="settings.wednesdaySlot"
                                        [(allowedPersons)]="settings.wednesdayAllowedPerson"></app-slot-table-item>
                                </td>
                                <td>
                                    <app-slot-table-item [(slot)]="settings.thursdaySlot"
                                        [(allowedPersons)]="settings.thursdayAllowedPerson"></app-slot-table-item>
                                </td>
                                <td>
                                    <app-slot-table-item [(slot)]="settings.fridaySlot"
                                        [(allowedPersons)]="settings.fridayAllowedPerson"></app-slot-table-item>
                                </td>
                                <td>
                                    <app-slot-table-item [(slot)]="settings.saturdaySlot"
                                        [(allowedPersons)]="settings.saturdayAllowedPerson"></app-slot-table-item>
                                </td>
                                <td>
                                    <app-slot-table-item [(slot)]="settings.sundaySlot"
                                        [(allowedPersons)]="settings.sundayAllowedPerson"></app-slot-table-item>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <small class="form-text text-muted">*
                        {{'USER.RESERVATIONS.SLOT.TABLE.slotTimeHelpText' | translate}}</small>
                </div>
            </div>
            <div class="row">
                <div class="col text-end">
                    <button type="button" class="btn btn-outline-primary btn-sm"
                        (click)="onSettingsSubmit()">{{'GENERAL.save' | translate}}</button>
                </div>
            </div>
        </form>
    </div>
</div>
<app-toast></app-toast>